import { infiniteQueryOptions } from '@tanstack/react-query';
import { loadTokensPage } from '@/server/functions/pages/tokens';

type TokensPageOpts = {
  search?: string;
  tags?: string[];
};

const tokensQueryKey = (orgSlug: string, opts?: TokensPageOpts) => ['tokens-page', orgSlug, opts ?? {}] as const;

export const tokensInfiniteQueryOptions = (orgSlug: string, opts?: TokensPageOpts) =>
  infiniteQueryOptions({
    queryKey: tokensQueryKey(orgSlug, opts),
    queryFn: ({ pageParam }) =>
      loadTokensPage({
        data: {
          orgSlug,
          cursor: pageParam,
          search: opts?.search,
          tags: opts?.tags,
        },
      }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
  });
